import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Button, Form, Modal, Badge, Spinner, Dropdown, DropdownButton } from "react-bootstrap";
import { payInvoiceWithAccountBalance, changeInvoiceService } from "../services/servicesService";
import { getCustomerEquipments } from "../services/equipmentService";
import { getTariffsForCustomer } from "../services/tariffService";
import FormComponent from "./common/formComponent";
import ErrorBoundary from "./common/errorBoundary";
import { formatNumber, round } from "../services/util";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PageLoading from "./common/pageLoading";
import FloatingAddButton from "./common/floatingAddButton";
import { StyledTableCell, StyledTableRow } from "../services/tableStyles";
import { getCustomerInvoices, addInvoice, downloadInvoice } from "../services/saleService";
import { getCustomerAccountBalance } from "../services/transactionService";
import Paystack from "./common/paystack";
import Flutterwave from "./common/flutterwave";
import { getUserById } from "../services/userService";
import { getWallet } from "../services/walletService";

class CustomerInvoices extends FormComponent {
  state = {
    data: {
      invoiceId: "",
      tariffId: "",
      equipmentId: "",
    },
    customerId: this.props.match.params.id,
    customer: {},
    tariffs: [],
    action: "",
    invoiceType: "",
    equipmentTariffs: [],
    errors: {},
    equipments: [],
    invoices: [],
    showPayModal: false,
    showAddModal: false,
    showWalletModal: false,
    showVerificationText: false,
    showResourceInvoiceFields: false,
    showServiceInvoiceFields: false,
    selectedInvoice: {},
    invoiceWallet: {},
    loading: true,
    processing: false,
  };

  schema = {
    invoiceId: Joi.string().required().label("Invoice"),
    tariffId: Joi.string().required().label("Tariff"),
    equipmentId: Joi.string().required().label("Equipment"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });

    if (this.state.action === "change plan") {
      try {
        await changeInvoiceService(this.state.data);
        await this.populateInvoices();
        await this.getAccountBalance();

        this.setState({ showChangeModal: false });

        toast.success("Plan changed successfully");
      } catch (ex) {
        if (
          ex.response &&
          ex.response.status >= 400 &&
          ex.response.status < 500
        ) {
          toast.error(ex.response.data);
        }
      }
    } else if (this.state.action === "add invoice") {
      try {
        await addInvoice({
          equipmentId: this.state.data.equipmentId,
          invoiceType: this.state.invoiceType,
        });
        this.setState({ showAddModal: false });
        await this.populateInvoices();
        toast.success("Invoice added successfully");
      } catch (ex) {
        if (
          ex.response &&
          ex.response.status >= 400 &&
          ex.response.status < 500
        ) {
          toast.error(ex.response.data);
        }
      }
    }

    this.setState({ processing: false });
  };

  async componentDidMount() {
    await this.getAccountBalance();
    await this.populateInvoices();
    await this.populateEquipments();
    await this.getCustomer();

    if (this.state.equipments.length > 0) {
      await this.getTariffs();
    }
  }

  async getTariffs() {
    const { customerId } = this.state;

    try {
      const { data: equipmentTariffs } = await getTariffsForCustomer(
        customerId
      );
      this.setState({ equipmentTariffs });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async populateEquipments() {
    const { match } = this.props;
    const customerId = match.params.id;

    try {
      const { data: equipments } = await getCustomerEquipments(customerId);
      this.setState({ equipments });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
  }

  async populateInvoices() {
    const { customerId } = this.state;

    try {
      const { data: invoices } = await getCustomerInvoices(customerId);
      this.setState({ invoices });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async getCustomer() {
    const { customerId } = this.state;

    try {
      const { data: customer } = await getUserById(customerId);
      this.setState({ customer });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ loading: false });
  }

  async getAccountBalance() {
    const { match } = this.props;
    const customerId = match.params.id;

    try {
      const { data: accountBalance } = await getCustomerAccountBalance(
        customerId
      );
      this.setState({ accountBalance: accountBalance.accountBalance });
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
  }

  async getInvoiceWallet(identifier, isPrimary) {
    try {
      const { data: wallet } = await getWallet(identifier, isPrimary);
      this.setState({ invoiceWallet: wallet });
      return wallet;
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
  }

  payWithAccountBalance = async (invoice) => {
    this.setState({ processing: true });

    try {
      const { data: response } = await payInvoiceWithAccountBalance(
        invoice._id
      );

      const selectedInvoice = { ...this.state.selectedInvoice };
      selectedInvoice.amountPayable =
        selectedInvoice.amountPayable - this.state.accountBalance;

      await this.getAccountBalance();
      await this.populateInvoices();

      this.setState({ selectedInvoice });

      if (response.newAmountPayable < 1) {
        this.setState({ showPayModal: false });
        toast.success("Payment Successful");
      } else {
        toast.success("Partial Payment Successful");
        toast("Please complete the payment with Paystack or Flutterwave");
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  handleShowPayModal = (invoice) => {
    const selectedInvoice = invoice;

    if (invoice.type === "Service") {
      this.getInvoiceWallet(invoice.equipmentId, false);
    } else if (invoice.type === "Sale") {
      this.getInvoiceWallet(invoice.user._id, false);
    }

    this.setState({ selectedInvoice, showPayModal: true });
  };

  handleShowWalletModal = () => {
    this.setState({ showWalletModal: true });
  };

  handleShowChangeModal = (invoice) => {
    const data = { ...this.state.data };
    const { equipmentTariffs } = this.state;
    data.invoiceId = invoice._id;
    data.equipmentId = invoice.equipmentId;
    const tariffs = equipmentTariffs[invoice.equipmentId];
    this.setState({
      data,
      tariffs,
      action: "change plan",
      showChangeModal: true,
    });
  };

  handleDownloadInvoice = async (invoice) => {
    let invoiceWallet = {};
    if (invoice.type == "Service") {
      invoiceWallet = await this.getInvoiceWallet(invoice.equipmentId, false);
    } else {
      invoiceWallet = await this.getInvoiceWallet(invoice.user._id, false);
    }
    let items = [];
    let formattedItem = {};
    {
      invoice.saleItems.forEach((item) => {
        formattedItem = {
          name: item.name,
          quantity: item.quantity,
          unit_cost: item.price,
        };

        items.push(formattedItem);
      });
    }
    let amountToDisplayOnlinePaymentButton = invoice.amountPayable;

    let walletInfo =
      invoice.amountPayable > 0
        ? `Please make a payment to the following account for automatic verification\n\nAmount Payable: NGN ${formatNumber(
            round(
              amountToDisplayOnlinePaymentButton +
                this.calculatePaystackFinalAmount(
                  amountToDisplayOnlinePaymentButton
                ).fee,
              2
            )
          )}\nAccount Number: ${invoiceWallet.account_number}\nAccount Name: ${
            invoiceWallet.account_name
          }\nBank Name: ${invoiceWallet.bank}
      \nPlease be sure to include the NGN ${formatNumber(
        round(
          this.calculatePaystackFinalAmount(amountToDisplayOnlinePaymentButton)
            .fee,
          2
        )
      )} transaction fee in the amount to be transfered, otherwise the system will be unable to verify the payment.`
        : ``;

    const payload = {
      date: invoice.formattedDate,
      from: "SmartCiti Fiber\nsales@smartciti.com.ng\n07045488561",
      to: `${invoice.user.fullName}\n${invoice.user.email}\n${invoice.user.address}`,
      logo: "https://smartciti-artefacts.s3.eu-west-2.amazonaws.com/images/logo-color.jpg",
      number: invoice.invoiceNumber,
      currency: "NGN",
      // fields: {
      //   discounts: true,
      //   shipping: false,
      //   tax: "#",
      // },
      // discounts: +500,
      // tax: 7.5,
      // tax_title: "VAT (7.5%)",
      amount_paid: `${invoice.transactionsTotal}`,

      items,
      notes: walletInfo,
    };

    try {
      const { data: generatedInvoice } = await downloadInvoice(payload);
      const blob = new Blob([generatedInvoice], { type: "application/pdf" });

      // For browsers that support msSaveOrOpenBlob (IE)
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, `${invoice.invoiceNumber}.pdf`);
      } else {
        // Create a temporary URL for the blob and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${invoice.invoiceNumber}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (ex) {
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        toast.error(ex.response.data);
      }
    }
  };

  handleShowAddModal = () => {
    this.setState({ showAddModal: true });
  };

  handleSelectInvoiceType = async (e) => {
    const invoiceType = e.currentTarget.value;

    const data = { ...this.state.data };
    data.invoiceId = "filler string";
    data.tariffId = "filler string";

    if (invoiceType === "Service") {
      this.setState({
        showServiceInvoiceFields: true,
        showResourceInvoiceFields: false,
      });
    } else if (invoiceType === "Resource") {
      this.setState({
        showResourceInvoiceFields: true,
        showServiceInvoiceFields: false,
      });
    }

    this.setState({ data, invoiceType, action: "add invoice" });
  };

  handleClose = () => {
    this.setState({
      showAddModal: false,
      showPayModal: false,
      showWalletModal: false,
      showChangeModal: false,
      showResourceInvoiceFields: false,
      showServiceInvoiceFields: false,
    });
  };

  closeOnlinePaymentTransaction = async () => {
    toast.success("Payment Successful");
    await this.populateInvoices();

    this.setState({
      showPayModal: false,
      showAddModal: false,
      showResourceInvoiceFields: false,
      showServiceInvoiceFields: false,
      showWalletModal: false,
      showVerificationText: false,
      processing: false,
    });
  };

  showOnlinePaymentVerification = () => {
    this.setState({ showVerificationText: true, processing: true });
  };

  calculateDuploFee = (price) => {
    const minFee = 10;
    const maxFee = 750;
    let finalAmount = price / (1 - 0.01) + 0.01;
    finalAmount = parseFloat(round(finalAmount, 2));
    let fee = finalAmount * 0.01;

    if (fee < minFee) {
      fee = minFee;
    } else if (fee > maxFee) {
      fee = maxFee;
    }

    fee = parseFloat(round(fee, 2));
    return fee;
  };

  calculatePaystackFinalAmount = (amount) => {
    const maxFee = 300;
    const decimalFee = 0.01;
    let finalAmount = amount / (1 - decimalFee);
    let chargedFee = finalAmount - amount;

    if (chargedFee < maxFee) {
    } else if (chargedFee > maxFee) {
      chargedFee = maxFee;
      finalAmount = amount + chargedFee;
    }
    return {
      finalAmount: round(finalAmount, 2),
      fee: round(chargedFee, 2),
    };
  };

  render() {
    const {
      customer,
      selectedInvoice,
      invoiceWallet,
      invoices,
      equipments,
      tariffs,
      accountBalance,
      errors,
      data,
      showPayModal,
      showAddModal,
      showWalletModal,
      showChangeModal,
      showResourceInvoiceFields,
      showServiceInvoiceFields,
      showVerificationText,
      loading,
      processing,
    } = this.state;

    let amountToDisplayInBalanceButton = 0;
    let amountToDisplayOnlinePaymentButton = selectedInvoice.amountPayable;
    if (accountBalance > selectedInvoice.amountPayable) {
      amountToDisplayInBalanceButton = selectedInvoice.amountPayable;
    } else {
      amountToDisplayInBalanceButton = accountBalance;
    }

    return (
      <React.Fragment>
        {loading && <PageLoading loading={loading} />}
        {!loading && invoices.length === 0 && (
          <span className="float-left mt-4">No Invoices to Display</span>
        )}
        {!loading && (
          <FloatingAddButton
            classes="float-right mt-2 mb-3"
            onClick={this.handleShowAddModal}
          />
        )}
        {!loading && invoices.length > 0 && (
          <TableContainer component={Paper} className="mt-4">
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Invoice Number</StyledTableCell>
                  <StyledTableCell align="right">Date</StyledTableCell>
                  <StyledTableCell align="right">Equipment</StyledTableCell>
                  <StyledTableCell align="right">Status</StyledTableCell>
                  <StyledTableCell align="right">Total</StyledTableCell>
                  <StyledTableCell align="right">
                    Amount Payable
                  </StyledTableCell>
                  <StyledTableCell align="right"></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoices.map((invoice) => (
                  <StyledTableRow key={invoice._id}>
                    <StyledTableCell component="th" scope="row">
                      {invoice.invoiceNumber}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {invoice.formattedDate}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {invoice.equipmentName}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <Badge
                        variant={`${
                          invoice.status === "Pending" ? "warning" : "success"
                        }`}
                      >
                        {invoice.status}
                      </Badge>
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      NGN {formatNumber(round(invoice.totalAmount, 2))}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      NGN {formatNumber(round(invoice.amountPayable, 2))}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      <DropdownButton
                        className="mb-2"
                        size="sm"
                        id="dropdown-success-button"
                        title="Actions"
                      >
                        {invoice.status !== "Paid" &&
                          invoice.amountPayable > 0 && (
                            <Dropdown.Item
                              onClick={() => this.handleShowPayModal(invoice)}
                            >
                              Pay Invoice
                            </Dropdown.Item>
                          )}
                        {invoice.status !== "Paid" &&
                          invoice.type === "Service" &&
                          invoice.amountPayable > 0 && (
                            <Dropdown.Item
                              onClick={() =>
                                this.handleShowChangeModal(invoice)
                              }
                            >
                              Change Plan
                            </Dropdown.Item>
                          )}
                        <Dropdown.Item
                          onClick={() => this.handleDownloadInvoice(invoice)}
                        >
                          Download Invoice
                        </Dropdown.Item>
                        <Dropdown.Divider />
                        {invoice.status === "Pending" && (
                          <Dropdown.Item onClick>Delete</Dropdown.Item>
                        )}
                      </DropdownButton>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Modal centered show={showPayModal} size="md" onHide={this.handleClose}>
          <Modal.Body>
            <center>
              {accountBalance > 0 && (
                <React.Fragment>
                  <Button
                    size="lg"
                    className="ml-2"
                    disabled={processing}
                    onClick={() => this.payWithAccountBalance(selectedInvoice)}
                    variant="success"
                  >
                    {processing && (
                      <Spinner
                        as="span"
                        className="mr-2 ml-2"
                        animation="border"
                        size="lg"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Pay NGN{" "}
                    {formatNumber(round(amountToDisplayInBalanceButton, 2))}{" "}
                    With Account Balance
                  </Button>
                  <br />
                  <hr />
                </React.Fragment>
              )}

              <Button
                size="lg"
                className="ml-2 mb-2"
                disabled={processing}
                onClick={() => this.handleShowWalletModal()}
                variant="success"
              >
                {processing && (
                  <Spinner
                    as="span"
                    className="mr-2 ml-2"
                    animation="border"
                    size="lg"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                Pay &#8358;{formatNumber(amountToDisplayOnlinePaymentButton)} +
                &#8358;
                {formatNumber(
                  round(
                    this.calculatePaystackFinalAmount(
                      amountToDisplayOnlinePaymentButton
                    ).fee,
                    2
                  )
                )}{" "}
                Fee With Bank Transfer
              </Button>

              {showVerificationText === true && (
                <span className="mb-3">
                  <b>Verifying transaction. Please do not reload the page</b>
                </span>
              )}
              <Button
                size="lg"
                className="mb-2"
                disabled={processing}
                type="button"
                variant="warning"
              >
                <ErrorBoundary
                  message={"Flutterwave Is Temporarily Unavailable"}
                >
                  <Flutterwave
                    verifyPayment={this.showOnlinePaymentVerification}
                    callBackFromParent={this.closeOnlinePaymentTransaction}
                    invoice={selectedInvoice}
                    customer={customer}
                    amount={amountToDisplayOnlinePaymentButton}
                  ></Flutterwave>
                </ErrorBoundary>
              </Button>
              {/* just uncomment to continue with paystack */}
              {/* <Button size="lg" className="mb-2" disabled={processing} type="button" variant="warning">
                <Paystack
                  verifyPayment={this.showOnlinePaymentVerification}
                  callBackFromParent={this.closeOnlinePaymentTransaction}
                  invoice={selectedInvoice}
                  email={customer.email}
                  amount={amountToDisplayOnlinePaymentButton}
                ></Paystack>
              </Button> */}
            </center>
          </Modal.Body>
        </Modal>

        <Modal show={showChangeModal} size="md" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Change Plan</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              <React.Fragment>
                <Form.Group controlId="tariff">
                  <Form.Label>New Plan</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    name="tariffId"
                    onChange={this.handleChange}
                    value={data.tariffId}
                    size="sm"
                  >
                    <option value="">Select Tariff</option>
                    {tariffs.map((tariff) => (
                      <option key={tariff._id} value={tariff._id}>
                        {tariff.title} - &#8358;
                        {formatNumber(round(tariff.price, 2))}
                      </option>
                    ))}
                  </Form.Control>
                  {errors.tariffId && (
                    <span className="text-danger">{errors.tariffId}</span>
                  )}
                </Form.Group>
              </React.Fragment>
              <span className="text-danger">
                *All previous payments for this invoice will be passed back to
                your account balance
              </span>
              <br />
              <br />
              <span className="text-danger">
                *New service will only begin after the current service expires
              </span>
            </Modal.Body>

            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button
                disabled={this.validate() || processing}
                type="submit"
                variant="primary"
              >
                {processing && (
                  <Spinner
                    as="span"
                    className="mr-2"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                Change Plan
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          centered
          show={showWalletModal}
          size="md"
          onHide={this.handleClose}
        >
          <Modal.Body>
            <center>
              Please make a payment to the following account for automatic
              verification
              <br />
              <br />
              <b>
                Amount Payable: NGN{" "}
                {formatNumber(
                  round(
                    amountToDisplayOnlinePaymentButton +
                      this.calculatePaystackFinalAmount(
                        amountToDisplayOnlinePaymentButton
                      ).fee,
                    2
                  )
                )}
                <br />
                Account Number: {invoiceWallet.account_number}
                <br />
                Account Name: {invoiceWallet.account_name}
                <br />
                Bank Name: {invoiceWallet.bank}
              </b>
              <br />
              <br />
              <i style={{ color: "red" }}>
                Please be sure to include the NGN{" "}
                {formatNumber(
                  round(
                    this.calculatePaystackFinalAmount(
                      amountToDisplayOnlinePaymentButton
                    ).fee,
                    2
                  )
                )}{" "}
                transaction fee in the amount to be transfered, otherwise the
                system will be unable to verify the payment.
              </i>
            </center>
          </Modal.Body>
        </Modal>

        <Modal show={showAddModal} size="md" onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Invoice</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              as="select"
              custom
              name="invoiceType"
              onChange={this.handleSelectInvoiceType}
              size="sm"
              type="text"
            >
              <option value="">Select Invoice Type</option>
              <option>Service</option>
              <option>Resource</option>
            </Form.Control>
          </Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            <Modal.Body>
              {showServiceInvoiceFields === true && equipments.length > 0 && (
                <React.Fragment>
                  <Form.Group controlId="equipmentId">
                    <Form.Label>Equipment</Form.Label>
                    <Form.Control
                      as="select"
                      custom
                      name="equipmentId"
                      onChange={this.handleChange}
                      value={data.equipmentId}
                      size="sm"
                      type="text"
                    >
                      <option value="">Select Equipment</option>
                      {equipments.map((equipment) => (
                        <option key={equipment._id} value={equipment._id}>
                          {equipment.name} ({equipment.sn})
                        </option>
                      ))}
                    </Form.Control>
                    {errors.equipmentId && (
                      <span className="text-danger">{errors.equipmentId}</span>
                    )}
                  </Form.Group>
                </React.Fragment>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleClose} variant="secondary">
                Close
              </Button>
              <Button
                disabled={this.validate() || processing}
                type="submit"
                variant="primary"
              >
                {processing && (
                  <Spinner
                    as="span"
                    className="mr-2"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                )}
                Add
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </React.Fragment>
    );
  }
}

export default CustomerInvoices;
